import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Preferential-index-1992f2b7eca2a3bef-1'),
    routerUrl: '/Preferential',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Preferential')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Preferential-index-1992f2b7eca2a3bef-2'),
        routerUrl: '/PreferentialForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./PreferentialForm')),
      },
      //$MORE$
    ],
  },
];
